module.exports = __webpack_public_path__ + "img/girl_qstand.0caeb9b6.jpg";